// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Dictionary__dictionary___1EPzK{display:flex;flex-direction:column;overflow:hidden;height:100%}\n", ""]);
// Exports
exports.locals = {
	"dictionary": "Dictionary__dictionary___1EPzK"
};
module.exports = exports;
